import * as Yup from "yup";
import { getLocalPhoneNumber } from "../../../../helpers/utils";
/* eslint-disable no-useless-escape */
export const DeleteAccountValidation = (
  t,
  countryCode,
  attrMap,
  isLoggedIn
) => {
  return Yup.object({
    loginMethod: Yup.string().oneOf(["email", "phone_number"]).required(),

    email: Yup.string().when("loginMethod", (loginMethod, schema) => {
      let s = schema;
      if (loginMethod[0] === "email") {
        s = s
          .required(t("auth.email.required"))
          .matches(
            /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,8})$/,
            t("auth.email.validMessage")
          );
        if (isLoggedIn && attrMap?.email) {
          s = s.test(
            "match-attr-email",
            t("userDelete.mustMatchEmail"),
            (value) => value === attrMap.email
          );
        }
      } else {
        s = s.notRequired();
      }
      return s;
    }),

    phone_number: Yup.string().when("loginMethod", (loginMethod, schema) => {
      let s = schema;
      if (loginMethod?.[0] === "phone_number") {
        s = s.required(t("auth.phoneNumber.validMessage"));
        if (!isLoggedIn) {
          s = s.matches(
            countryCode === "TR"
              ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ // (XXX) XXX XXXX
              : /^\d{13}$/,
            t("auth.phoneNumber.validMessage")
          );
        }
        if (isLoggedIn && attrMap?.phone_number) {
          s = s.test(
            "match-attr-phone",
            t("userDelete.mustMatchPhone"),
            (value) => value === getLocalPhoneNumber(attrMap, countryCode)
          );
        }
      } else {
        s = s.notRequired();
      }
      return s;
    }),

    countryCode: Yup.string().when("loginMethod", (loginMethod, schema) => {
      return loginMethod[0] === "phone_number"
        ? schema.required(t("auth.country.required"))
        : schema.notRequired();
    }),
    password: Yup.string().required(t("auth.password.passwordRequired")),
  });
};
